import { AppDispatch, RootState } from '../store';
import { fetchUsers } from './userActions';
import { clearUserData } from '../slices/userSlice';

export const forceRefreshEmployees = () => async (dispatch: AppDispatch) => {
  try {
    console.log('Force refreshing employees data...');
    dispatch(clearUserData());
    await dispatch(fetchUsers({ forceRefresh: true })).unwrap();
    console.log('Employees data force refreshed successfully');
    return true;
  } catch (error) {
    console.error('Failed to force refresh employees data:', error);
    return false;
  }
};
